import { MedicalRecord, IMedicalTemplate } from "../../interface/MedicalRecord";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface MedicalRecordState {
  record: MedicalRecord | null;
  followUp: MedicalRecord | null;
  template: IMedicalTemplate | null;
  status: "idle" | "loading" | "success" | "error";
  error?: string;
}




const initialState: MedicalRecordState = {
  record: null,
  followUp: null,
  template: null,
  status: "idle",
};

const medicalRecordSlice = createSlice({
  name: "medicalRecord",
  initialState,
  reducers: {
    setMedicalTemplate(
      state,
      action: PayloadAction<IMedicalTemplate | null>
    ) {
      state.template = action.payload;
    },

    clearMedicalTemplate(state) {
      state.template = null;
    },

    setMedicalRecord(
      state,
      action: PayloadAction<MedicalRecord | null>
    ) {
      state.record = action.payload;
    },

    clearMedicalRecord(state) {
      state.record = null;
    },

    resetMedicalRecord() {
      return initialState;
    },
    setFollowUp(
      state,
      action: PayloadAction<MedicalRecord | null>
    ) {
      state.followUp = action.payload;
    },
    clearFollowUp(state) {
      state.followUp = null;
    },
  },
});

export const {
  setMedicalTemplate,
  clearMedicalTemplate,
  setMedicalRecord,
  clearMedicalRecord,
  resetMedicalRecord,
  setFollowUp,
  clearFollowUp
} = medicalRecordSlice.actions;

export default medicalRecordSlice.reducer;
